import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./src/app/mixins/input-eventbus.js